import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Image, Link, Text } from '@chakra-ui/react';
import { Card, Button, ChevronRight, Icon } from '@whitbread-eos/atoms';
import { SRHotelBadges, SRHotelDistance, SRHotelFacilities, SRHotelThumbnail, SRHotelTitle } from '@whitbread-eos/molecules';
import { formatDataTestId, useCustomLocale, useSemanticTypography } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HotelCard(_ref) {
  var _data$links$detailsPa, _data$links, _data$brand, _data$name, _data$topSectionImage, _data$topSectionImage2, _data$topSectionImage3, _data$topSectionImage4, _data$tripAdvisorRevi, _data$tripAdvisorRevi2;
  var data = _ref.data,
    hideHotelDistance = _ref.hideHotelDistance;
  var baseDataTestId = 'DLP';
  var getTypographyProps = useSemanticTypography();
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hotelSlug = (_data$links$detailsPa = data === null || data === void 0 || (_data$links = data.links) === null || _data$links === void 0 ? void 0 : _data$links.detailsPage) !== null && _data$links$detailsPa !== void 0 ? _data$links$detailsPa : '';
  var hotelBrand = (_data$brand = data === null || data === void 0 ? void 0 : data.brand) !== null && _data$brand !== void 0 ? _data$brand : '';
  var hotelName = (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : '';
  var imageURLHotelExterior = "".concat((_data$topSectionImage = data === null || data === void 0 || (_data$topSectionImage2 = data.topSectionImages) === null || _data$topSectionImage2 === void 0 || (_data$topSectionImage2 = _data$topSectionImage2[0]) === null || _data$topSectionImage2 === void 0 ? void 0 : _data$topSectionImage2.imageSrc) !== null && _data$topSectionImage !== void 0 ? _data$topSectionImage : t('dlp.hotelCard.img.placeholder'));
  var imageAltText = "".concat(hotelName, " ").concat((_data$topSectionImage3 = data === null || data === void 0 || (_data$topSectionImage4 = data.topSectionImages) === null || _data$topSectionImage4 === void 0 || (_data$topSectionImage4 = _data$topSectionImage4[0]) === null || _data$topSectionImage4 === void 0 || (_data$topSectionImage4 = _data$topSectionImage4.tags) === null || _data$topSectionImage4 === void 0 ? void 0 : _data$topSectionImage4[0]) !== null && _data$topSectionImage3 !== void 0 ? _data$topSectionImage3 : 'exterior');
  var hotelBrandLogos = {
    hubLogo: t('dlp.hotelCard.hubBadge'),
    zipLogo: t('dlp.hotelCard.zipBadge')
  };
  var hotelDistanceLabels = {
    distanceUnitPlural: t('dlp.hotelCard.distance.unitPlural'),
    fromLocation: t('dlp.hotelCard.distance.fromLocation')
  };
  var URLToRedirect = "/".concat(country, "/").concat(language, "/hotels").concat(hotelSlug, ".html");
  return _jsx(Box, _objectSpread(_objectSpread({}, wrapperStyles), {}, {
    children: _jsx(Link, _objectSpread(_objectSpread({
      href: URLToRedirect
    }, linkStyles), {}, {
      children: _jsx(Card, _objectSpread(_objectSpread({}, cardContainerStyles), {}, {
        "data-testid": formatDataTestId(baseDataTestId, 'hotel-card'),
        children: _jsxs(Flex, {
          direction: "column",
          w: "full",
          children: [_jsx(SRHotelThumbnail, {
            imageData: {
              imageSrc: imageURLHotelExterior,
              imageAlt: imageAltText
            },
            brand: hotelBrand,
            brandLogos: hotelBrandLogos,
            testId: formatDataTestId(baseDataTestId, 'hotel-thumbnail'),
            styles: hotelThumbnailWrapperStyles
          }), _jsxs(Flex, _objectSpread(_objectSpread({}, hotelDetailsBoxStyles), {}, {
            children: [_jsx(SRHotelTitle, {
              title: hotelName,
              testId: formatDataTestId(baseDataTestId, 'hotel-title'),
              styles: _objectSpread(_objectSpread({}, titleStylesLayout), getTypographyProps(titleLegacyTypography, titleSemanticTypography))
            }), !hideHotelDistance && (data === null || data === void 0 ? void 0 : data.distanceFromReference) && _jsx(SRHotelDistance, {
              distance: parseFloat(data === null || data === void 0 ? void 0 : data.distanceFromReference.toFixed(2)),
              unit: "miles",
              labels: hotelDistanceLabels,
              testId: formatDataTestId(baseDataTestId, 'hotel-distance'),
              styles: _objectSpread(_objectSpread({}, hotelDistanceLayoutStyles), getTypographyProps(hotelDistanceLegacyTypography, hotelDistanceSemanticTypography))
            }), _jsx(SRHotelBadges, {
              testId: formatDataTestId(baseDataTestId, 'hotel-badges'),
              messagingFlag: data === null || data === void 0 ? void 0 : data.messagingFlag,
              hotelFacilities: data === null || data === void 0 ? void 0 : data.hotelFacilities,
              labels: {
                premierPlus: t('hoteldetails.rates.premierplus')
              },
              styles: hotelBadgesStyles
            }), ' ', (data === null || data === void 0 || (_data$tripAdvisorRevi = data.tripAdvisorReviews) === null || _data$tripAdvisorRevi === void 0 ? void 0 : _data$tripAdvisorRevi.reviews) && (data === null || data === void 0 || (_data$tripAdvisorRevi2 = data.tripAdvisorReviews) === null || _data$tripAdvisorRevi2 === void 0 ? void 0 : _data$tripAdvisorRevi2.rating) && _jsxs(Flex, {
              mb: "sm",
              children: [_jsx(Image, _objectSpread(_objectSpread({}, taImageStyles), {}, {
                src: "https://static.tacdn.com/img2/ratings/traveler/".concat((Math.round(data.tripAdvisorReviews.rating * 2) / 2).toFixed(1), ".svg"),
                alt: "ta-ratings-img"
              })), _jsx(Link, _objectSpread(_objectSpread({
                href: "".concat(URLToRedirect, "#tripadvisor-reivew-section-bottom"),
                target: "_blank"
              }, taReviewsStyles), {}, {
                children: "".concat(data.tripAdvisorReviews.numberOfReviews, " ").concat(t('hoteldetails.tripadvisorreviews'))
              }))]
            }), (data === null || data === void 0 ? void 0 : data.hotelFacilities) && _jsx(SRHotelFacilities, {
              facilities: data === null || data === void 0 ? void 0 : data.hotelFacilities,
              roomTypes: [],
              isDLPPage: true
            })]
          })), _jsxs(Flex, _objectSpread(_objectSpread({
            justifyContent: "space-between",
            gap: "md"
          }, hotelButtonBoxStyles), {}, {
            "data-testid": formatDataTestId(baseDataTestId, 'hotel-button'),
            children: [_jsx(Text, {
              fontWeight: "bold",
              fontSize: "sm",
              lineHeight: "3",
              children: t('dlp.hotelCard.viewHotel')
            }), _jsx(Button, _objectSpread(_objectSpread({
              "aria-label": t('dlp.hotelCard.viewHotel'),
              size: "xxs",
              variant: "circle"
            }, buttonStyles), {}, {
              children: _jsx(Icon, {
                svg: _jsx(ChevronRight, {
                  color: "var(--chakra-colors-baseWhite)"
                })
              })
            }))]
          }))]
        })
      }))
    }))
  }));
}
var wrapperStyles = {
  w: {
    mobile: 'full',
    xs: '22.375rem',
    sm: '16.25rem',
    md: '14.313rem',
    lg: '18.375rem',
    xl: '19.312rem'
  }
};
var linkStyles = {
  display: 'flex',
  h: '100%',
  cursor: 'default',
  _hover: {
    textDecoration: 'none'
  },
  _focus: {
    textDecoration: 'none',
    boxShadow: 'none'
  },
  _visited: {
    textDecoration: 'none'
  },
  _link: {
    textDecoration: 'none'
  },
  _active: {
    textDecoration: 'none'
  }
};
var cardContainerStyles = {
  bgColor: 'baseWhite',
  w: 'full',
  minH: {
    mobile: 'auto',
    sm: '27.25rem',
    xl: '25.875rem'
  },
  border: '1px solid var(--chakra-colors-lightGrey4)',
  borderRadius: 'var(--chakra-space-radiusSmall)',
  boxShadow: 'none',
  padding: '0',
  _hover: {
    cursor: 'pointer',
    boxShadow: '0 0 var(--chakra-space-sm) 0 var(--chakra-colors-lightGrey2)',
    transitionProperty: 'border, box-shadow',
    transitionDuration: '0s, 0s',
    transitionTimingFunction: 'ease, ease',
    transitionDelay: '0s, 0s'
  }
};
var titleStylesLayout = {
  color: 'darkGrey1'
};
var titleLegacyTypography = {
  fontSize: 'md',
  lineHeight: 'var(--chakra-lineHeights-3)',
  fontWeight: 'semibold'
};
var titleSemanticTypography = {
  textStyle: 'body-m-emphasis'
};
var hotelThumbnailWrapperStyles = {
  minH: '12.875rem'
};
var hotelDetailsBoxStyles = {
  px: {
    mobile: 'sm',
    sm: 'md'
  },
  py: {
    mobile: 'sm',
    sm: 'md'
  },
  flexDirection: 'column',
  w: 'full',
  minH: {
    mobile: 'auto',
    sm: '11.5rem',
    xl: '10.4rem'
  }
};
var hotelDistanceLayoutStyles = {
  paddingTop: {
    mobile: 'sm',
    sm: 'xs'
  },
  paddingBottom: 'sm',
  flex: 0
};
var hotelDistanceLegacyTypography = {
  fontSize: 'sm',
  fontWeight: 'normal',
  lineHeight: '2'
};
var hotelDistanceSemanticTypography = {
  textStyle: 'body-s-regular'
};
var hotelBadgesStyles = {
  mb: 'xmd'
};
var hotelButtonBoxStyles = {
  pl: {
    mobile: 'sm',
    md: '0'
  },
  pr: {
    mobile: '0'
  },
  alignSelf: 'end',
  m: 'auto var(--chakra-space-md) var(--chakra-space-md)'
};
var buttonStyles = {
  bgColor: 'primary',
  _hover: {
    bg: 'var(--chakra-colors-btnPrimaryHoverBg) radial-gradient(circle, transparent 1%, var(--chakra-colors-btnPrimaryHoverBg) 1%) center/15000%',
    boxShadow: '0 4px 8px var(--chakra-colors-lightGrey1)',
    _disabled: {
      bg: 'lightGrey3'
    }
  }
};
var taImageStyles = {
  h: '18px',
  ml: '-7px'
};
var taReviewsStyles = {
  fontSize: 'xxs'
};